// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as View from "../../primitives/View.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as CountryCode from "../../primitives/CountryCode.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as AnimatedRender from "../../primitives/AnimatedRender.res.js";
import * as CustomerRoutes from "../../app/Customer/CustomerRoutes.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CompanyLegalNumber from "../CompanyLegalNumber.res.js";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
let strategies = ["ByCompanyName", "ByCompactCompanyName", "ByCompanyNameInDepartment", "ByStreet", "ByDirectorName", "ByReversedDirectorName", "ByCompanyNameAndCity"];
let placeholders = ["na", "nc", "noncommunique", "inconnu", "xxx", "x"];
function sanitize(value) {
  return value.replace(/\s+/g, " ").trim();
}
let diacritics = new RegExp("[\\u0300-\\u036f]", "g");
function foldAccents(value) {
  return value.toLowerCase().normalize("NFD").replace(diacritics, "");
}
function words(value) {
  return foldAccents(value).replace(/[^a-z0-9]+/g, " ").trim().split(" ").filter(word => word !== "");
}
function compact(value) {
  return words(value).join("");
}
let legalForms = ["ass", "asso", "association", "earl", "ei", "eirl", "eurl", "gaec", "gie", "sa", "sarl", "sas", "sasu", "sc", "sca", "scea", "sci", "scic", "scm", "scop", "scp", "scs", "selarl", "selas", "sem", "snc", "groupe"];
function withoutLegalForm(value) {
  let words$1 = sanitize(value).split(" ").filter(word => word !== "");
  if (words$1.length < 2) {
    return words$1.join(" ");
  }
  let words$2 = legalForms.includes(words(words$1[0]).join("")) ? words$1.slice(1) : words$1;
  let lastIndex = words$2.length - 1 | 0;
  let words$3 = lastIndex >= 1 && legalForms.includes(words(words$2[lastIndex]).join("")) ? words$2.slice(0, lastIndex) : words$2;
  return words$3.join(" ");
}
function compactWithoutLegalForm(value) {
  let value$1 = withoutLegalForm(value);
  return words(value$1).join("");
}
function make(value) {
  let sanitized = sanitize(value);
  let compacted = words(sanitized).join("");
  if (sanitized.length < 3 || compacted === "" || placeholders.includes(compacted)) {
    return;
  } else {
    return sanitized;
  }
}
function makeWithoutLegalForm(value) {
  return Stdlib_Option.map(make(value), term => {
    let stripped = withoutLegalForm(term);
    if (stripped.length >= 3) {
      return stripped;
    } else {
      return term;
    }
  });
}
function makePostalCode(value) {
  let postalCode = value.replace(/\s/g, "");
  if (/^[0-9]{5}$/.test(postalCode)) {
    return postalCode;
  }
}
let overseasDepartments = ["971", "972", "973", "974", "975", "976", "977", "978", "984", "986", "987", "988", "989"];
function makeDepartment(postalCode) {
  let department = postalCode.slice(0, 2);
  switch (department) {
    case "97":
    case "98":
      break;
    default:
      if (department >= "01" && department <= "95" && department !== "20") {
        return department;
      } else {
        return;
      }
  }
  let department$1 = postalCode.slice(0, 3);
  if (overseasDepartments.includes(department$1)) {
    return department$1;
  }
}
let CustomerCompanySuggestionSearchTerm = {
  minimumLength: 3,
  placeholders: placeholders,
  sanitize: sanitize,
  diacritics: diacritics,
  foldAccents: foldAccents,
  words: words,
  compact: compact,
  legalForms: legalForms,
  withoutLegalForm: withoutLegalForm,
  compactWithoutLegalForm: compactWithoutLegalForm,
  make: make,
  makeWithoutLegalForm: makeWithoutLegalForm,
  makePostalCode: makePostalCode,
  overseasDepartments: overseasDepartments,
  makeDepartment: makeDepartment
};
let baseEndpoint = "https://recherche-entreprises.api.gouv.fr/search";
let commonParams = [["etat_administratif", "A"], ["minimal", "true"], ["include", "siege,complements,matching_etablissements"], ["per_page", 25 .toString()]];
function toParams(strategy, criteria) {
  switch (strategy) {
    case "ByCompanyName":
      return Stdlib_Option.map(makeWithoutLegalForm(criteria.companyName), term => [["q", term]]);
    case "ByCompactCompanyName":
      return Stdlib_Option.flatMap(makeWithoutLegalForm(criteria.companyName), term => {
        let value = withoutLegalForm(term);
        let compacted = words(value).join("");
        if (compacted === foldAccents(term) || compacted.length < 3) {
          return;
        } else {
          return [["q", compacted]];
        }
      });
    case "ByCompanyNameInDepartment":
      return Stdlib_Option.map(makeWithoutLegalForm(criteria.companyName), term => [["q", term]]);
    case "ByStreet":
      return Stdlib_Option.map(make(criteria.street), term => [["q", term]]);
    case "ByDirectorName":
      let match = make(criteria.directorLastName);
      let match$1 = make(criteria.directorFirstName);
      if (match !== undefined && match$1 !== undefined) {
        return [["nom_personne", match], ["prenoms_personne", match$1]];
      } else {
        return;
      }
    case "ByReversedDirectorName":
      let match$2 = make(criteria.directorFirstName);
      let match$3 = make(criteria.directorLastName);
      if (match$2 !== undefined && match$3 !== undefined && words(match$2).join("") !== words(match$3).join("")) {
        return [["nom_personne", match$2], ["prenoms_personne", match$3]];
      } else {
        return;
      }
    case "ByCompanyNameAndCity":
      let match$4 = makeWithoutLegalForm(criteria.companyName);
      let match$5 = make(criteria.city);
      if (match$4 !== undefined && match$5 !== undefined) {
        return [["q", match$4 + " " + match$5]];
      } else {
        return;
      }
  }
}
function endpoint(params, scope) {
  let tmp;
  tmp = typeof scope !== "object" ? [] : scope.TAG === "InPostalCode" ? [["code_postal", scope._0]] : [["departement", scope._0]];
  return baseEndpoint + "?" + Belt_Array.concatMany([params, tmp, commonParams]).map(param => param[0] + "=" + encodeURIComponent(param[1])).join("&");
}
let Query = {
  baseEndpoint: baseEndpoint,
  commonParams: commonParams,
  toParams: toParams,
  endpoint: endpoint
};
let nonDiffusible = "[NON-DIFFUSIBLE]";
function sanitize$1(value) {
  if (value !== undefined && value !== nonDiffusible) {
    return value;
  } else {
    return "";
  }
}
function matchesScope(establishment, scope) {
  let match = Json.flatDecodeDictFieldString(establishment, "code_postal");
  if (typeof scope !== "object") {
    return true;
  } else if (scope.TAG === "InPostalCode") {
    if (match !== undefined) {
      return match === scope._0;
    } else {
      return false;
    }
  } else if (match !== undefined) {
    return match.startsWith(scope._0);
  } else {
    return false;
  }
}
function isClosed(establishment) {
  return Json.flatDecodeDictFieldString(establishment, "etat_administratif") === "F";
}
function isHeadOffice(establishment) {
  return Stdlib_Option.getOr(Json.flatDecodeDictFieldBoolean(establishment, "est_siege"), false);
}
function isFormerHeadOffice(establishment) {
  return Stdlib_Option.getOr(Json.flatDecodeDictFieldBoolean(establishment, "ancien_siege"), false);
}
function decodeHeadOffice(result) {
  return Stdlib_Option.filter(Json.flatDecodeDictFieldDict(result, "siege"), establishment => !isClosed(establishment));
}
function decodeAddressDict(result, scope) {
  if (typeof scope !== "object") {
    return decodeHeadOffice(result);
  }
  scope.TAG === "InPostalCode";
  let establishments = Stdlib_Array.filterMap(Stdlib_Option.getOr(Json.flatDecodeDictFieldArray(result, "matching_etablissements"), []), Json.decodeDict).filter(establishment => {
    if (matchesScope(establishment, scope) && !isClosed(establishment)) {
      return !isFormerHeadOffice(establishment);
    } else {
      return false;
    }
  });
  return Stdlib_Option.orElse(Stdlib_Option.orElse(establishments.find(isHeadOffice), establishments[0]), decodeHeadOffice(result));
}
function decodeCompanyName(result) {
  let soleProprietorship = Stdlib_Option.getOr(Json.flatDecodeDictFieldBoolean(Json.flatDecodeDictFieldDict(result, "complements"), "est_entrepreneur_individuel"), false);
  let companyName = sanitize$1(Json.flatDecodeDictFieldString(result, "nom_raison_sociale"));
  if (companyName !== "") {
    return companyName;
  }
  let fullName = sanitize$1(Json.flatDecodeDictFieldString(result, "nom_complet"));
  if (fullName === "") {
    return "";
  } else if (soleProprietorship) {
    return "EI " + fullName;
  } else {
    return fullName;
  }
}
function decodeCompactNames(result, addressDict) {
  let names = [Json.flatDecodeDictFieldString(result, "nom_raison_sociale"), Json.flatDecodeDictFieldString(result, "nom_complet"), Json.flatDecodeDictFieldString(result, "sigle"), Json.flatDecodeDictFieldString(addressDict, "nom_commercial")].map(sanitize$1).concat(Stdlib_Array.filterMap(Stdlib_Option.getOr(Json.flatDecodeDictFieldArray(addressDict, "liste_enseignes"), []), Json.decodeString)).flatMap(name => {
    let value = withoutLegalForm(name);
    return [words(name).join(""), words(value).join("")];
  }).filter(name => name !== "");
  return names.filter((name, index) => names.indexOf(name) === index);
}
function decodeCandidate(result, scope) {
  let addressDict = decodeAddressDict(result, scope);
  let siret = sanitize$1(Json.flatDecodeDictFieldString(addressDict, "siret"));
  let companyName = decodeCompanyName(result);
  if (siret === "" || companyName === "") {
    return;
  } else {
    return {
      suggestion: {
        siret: siret,
        companyName: companyName,
        postalCode: sanitize$1(Json.flatDecodeDictFieldString(addressDict, "code_postal")),
        city: sanitize$1(Json.flatDecodeDictFieldString(addressDict, "libelle_commune"))
      },
      compactNames: decodeCompactNames(result, addressDict)
    };
  }
}
function decode(json, scope) {
  let dict = Json.decodeDict(json);
  let totalResults = Json.flatDecodeDictFieldFloat(dict, "total_results");
  if (totalResults !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        totalResults: totalResults | 0,
        candidates: Stdlib_Array.filterMap(Stdlib_Option.getOr(Json.flatDecodeDictFieldArray(dict, "results"), []), result => decodeCandidate(Json.decodeDict(result), scope))
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}
let CustomerCompanySuggestionResponse = {
  nonDiffusible: nonDiffusible,
  sanitize: sanitize$1,
  matchesScope: matchesScope,
  isClosed: isClosed,
  isHeadOffice: isHeadOffice,
  isFormerHeadOffice: isFormerHeadOffice,
  decodeHeadOffice: decodeHeadOffice,
  decodeAddressDict: decodeAddressDict,
  decodeCompanyName: decodeCompanyName,
  decodeCompactNames: decodeCompactNames,
  decodeCandidate: decodeCandidate,
  decode: decode
};
function isEligible(strategy, totalResults, scope) {
  if (strategy === "ByStreet" && typeof scope !== "object") {
    return false;
  } else {
    return totalResults === 1;
  }
}
function scopeOf(strategy, scope) {
  switch (strategy) {
    case "ByCompanyNameInDepartment":
      if (typeof scope !== "object" || scope.TAG !== "InPostalCode") {
        return "Nationwide";
      } else {
        return Stdlib_Option.mapOr(makeDepartment(scope._0), "Nationwide", department => ({
          TAG: "InDepartment",
          _0: department
        }));
      }
    case "ByCompanyNameAndCity":
      return "Nationwide";
    default:
      return scope;
  }
}
function requiresCorroboration(strategy) {
  return strategy === "ByCompanyNameAndCity";
}
function carriesName(compactNames, compactCompanyName) {
  return compactNames.includes(compactCompanyName);
}
function containsName(compactNames, compactCompanyName) {
  return compactNames.some(name => {
    if (compactCompanyName.length >= 6 && name.includes(compactCompanyName)) {
      return true;
    } else if (name.length >= 6) {
      return compactCompanyName.includes(name);
    } else {
      return false;
    }
  });
}
function matchesName(compactNames, compactCompanyName) {
  if (compactNames.includes(compactCompanyName)) {
    return true;
  } else {
    return containsName(compactNames, compactCompanyName);
  }
}
function carriesDirectorName(compactNames, compactDirectorNames) {
  return compactDirectorNames.some(name => compactNames.includes(name));
}
function searchesDirector(strategy) {
  switch (strategy) {
    case "ByDirectorName":
    case "ByReversedDirectorName":
      return true;
    default:
      return false;
  }
}
function corroborate(candidates, matches) {
  let match = candidates.filter(param => matches(param.compactNames));
  if (match.length !== 1) {
    return;
  }
  let match$1 = match[0];
  return match$1.suggestion;
}
function selectByName(outcomes, compactCompanyName, compactDirectorNames) {
  return Stdlib_Array.findMap([(param, compactNames) => compactNames.includes(compactCompanyName), (param, compactNames) => containsName(compactNames, compactCompanyName), (strategy, compactNames) => {
    if (searchesDirector(strategy)) {
      return carriesDirectorName(compactNames, compactDirectorNames);
    } else {
      return false;
    }
  }], matches => Stdlib_Array.findMap(outcomes, param => {
    let outcome = param[1];
    let strategy = param[0];
    let matches$1 = compactNames => matches(strategy, compactNames);
    if (outcome.TAG !== "Ok") {
      return;
    }
    let match = outcome._0;
    if (match.totalResults <= 25) {
      return corroborate(match.candidates, matches$1);
    }
  }));
}
function selectByCount(outcomes, compactCompanyName, scope) {
  return Stdlib_Array.reduce(outcomes, {
    TAG: "Ok",
    _0: undefined
  }, (selected, param) => {
    let outcome = param[1];
    let strategy = param[0];
    if (selected.TAG !== "Ok") {
      return selected;
    }
    if (selected._0 !== undefined) {
      return selected;
    }
    if (outcome.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let match = outcome._0;
    let match$1 = isEligible(strategy, match.totalResults, scopeOf(strategy, scope));
    let match$2 = match.candidates[0];
    if (match$1 && match$2 !== undefined && !(requiresCorroboration(strategy) && !matchesName(match$2.compactNames, compactCompanyName))) {
      return {
        TAG: "Ok",
        _0: match$2.suggestion
      };
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  });
}
function selectSuggestion(outcomes, compactCompanyName, compactDirectorNamesOpt, scope) {
  let compactDirectorNames = compactDirectorNamesOpt !== undefined ? compactDirectorNamesOpt : [];
  let suggestion = selectByName(outcomes, compactCompanyName, compactDirectorNames);
  if (suggestion !== undefined) {
    return {
      TAG: "Ok",
      _0: suggestion
    };
  } else {
    return selectByCount(outcomes, compactCompanyName, scope);
  }
}
function make$1(params, scope) {
  let abortController = new AbortController();
  let abortSignal = abortController.signal;
  return Future.make(resolve => {
    Stdlib_Promise.$$catch(fetch(endpoint(params, scope), {
      method: "GET",
      signal: Primitive_option.some(abortSignal)
    }).then(prim => prim.json()).then(json => resolve(decode(json, scope))), param => {
      resolve({
        TAG: "Error",
        _0: undefined
      });
      return Promise.resolve();
    });
    return () => {
      abortController.abort();
    };
  });
}
let CustomerCompanySuggestionRequest = {
  make: make$1
};
function plans(criteria, scope) {
  return Stdlib_Array.filterMap(strategies.filter(strategy => {
    let match = scopeOf(strategy, scope);
    switch (strategy) {
      case "ByCompanyNameInDepartment":
      case "ByStreet":
        break;
      default:
        return true;
    }
    return typeof match === "object";
  }), strategy => Stdlib_Option.map(toParams(strategy, criteria), params => [strategy, params]));
}
function run(criteria, requestOpt) {
  let request = requestOpt !== undefined ? requestOpt : make$1;
  let scope = Stdlib_Option.mapOr(makePostalCode(criteria.postalCode), "Nationwide", postalCode => ({
    TAG: "InPostalCode",
    _0: postalCode
  }));
  let compactCompanyName = Stdlib_Option.mapOr(make(criteria.companyName), "", compactWithoutLegalForm);
  let match = make(criteria.directorFirstName);
  let match$1 = make(criteria.directorLastName);
  let compactDirectorNames;
  if (match !== undefined) {
    if (match$1 !== undefined) {
      let firstName = words(match).join("");
      let lastName = words(match$1).join("");
      compactDirectorNames = [firstName + lastName, lastName + firstName];
    } else {
      compactDirectorNames = [];
    }
  } else {
    compactDirectorNames = [];
  }
  let plans$1 = plans(criteria, scope);
  if (plans$1.length === 0) {
    return Future.value({
      TAG: "Ok",
      _0: undefined
    });
  }
  let futures = plans$1.map(param => request(param[1], scopeOf(param[0], scope)));
  return Future.make(resolve => {
    Future.get(Future.all(futures), outcomes => resolve(selectSuggestion(plans$1.map((param, index) => [param[0], outcomes[index]]), compactCompanyName, compactDirectorNames, scope)));
    return () => {
      futures.forEach(Future.cancel);
    };
  });
}
function criteriaKey(criteria) {
  return [criteria.companyName, criteria.directorFirstName, criteria.directorLastName, criteria.street, criteria.postalCode, criteria.city].join("\n");
}
function use(criteria, skipOpt, requestOpt) {
  let skip = skipOpt !== undefined ? skipOpt : false;
  let request = requestOpt !== undefined ? requestOpt : make$1;
  let match = React.useState(() => AsyncResult.notAsked());
  let setState = match[1];
  React.useEffect(() => {
    if (skip) {
      setState(param => AsyncResult.notAsked());
      return;
    }
    setState(AsyncData.toBusy);
    let future = run(criteria, request);
    Future.get(future, outcome => setState(param => AsyncResult.done(outcome)));
    return () => Future.cancel(future);
  }, [criteriaKey(criteria), skip]);
  return match[0];
}
let Engine = {
  minimumContainedNameLength: 6,
  resultsPerPage: 25,
  strategies: strategies,
  CustomerCompanySuggestionSearchTerm: CustomerCompanySuggestionSearchTerm,
  Query: Query,
  CustomerCompanySuggestionResponse: CustomerCompanySuggestionResponse,
  isEligible: isEligible,
  scopeOf: scopeOf,
  requiresCorroboration: requiresCorroboration,
  carriesName: carriesName,
  containsName: containsName,
  matchesName: matchesName,
  carriesDirectorName: carriesDirectorName,
  searchesDirector: searchesDirector,
  corroborate: corroborate,
  selectByName: selectByName,
  selectByCount: selectByCount,
  selectSuggestion: selectSuggestion,
  CustomerCompanySuggestionRequest: CustomerCompanySuggestionRequest,
  plans: plans,
  run: run,
  criteriaKey: criteriaKey,
  use: use
};
let i18nPrefix = "company_suggestion.";
function isCountryEligible(country, shopCountry) {
  let match = CountryCode.parseIso3166Alpha2(country);
  if (typeof match !== "object") {
    switch (match) {
      case "FR":
        return true;
      case "BE":
      case "LU":
        return false;
    }
  } else {
    let match$1 = CountryCode.parseIso3166Alpha2(shopCountry);
    if (typeof match$1 !== "object") {
      return match$1 === "FR";
    } else {
      return false;
    }
  }
}
let styles = {
  CompanySuggestion_svg: {
    "backgroundImage-kKwaWg": "backgroundImage-x1uzhv9z",
    "backgroundPosition-k1YJky": "backgroundPosition-x1xsqp64",
    "backgroundRepeat-kz484i": "backgroundRepeat-xiy17q3",
    "backgroundSize-kgSjnq": "backgroundSize-x18d0r48",
    "flexShrink-kmuXW": "flexShrink-x2lah0s",
    "height-kZKoxP": "height-x1fgtraw",
    "width-kzqmXN": "width-xgd8bvy",
    $$css: "wino-gc:src/modules/Customer/CustomerCompanySuggestion.res.js:782"
  }
};
function CustomerCompanySuggestion$CompanySuggestionSurface(props) {
  let suggestion = props.suggestion;
  let companyName = suggestion.companyName;
  let siret = suggestion.siret;
  let variant = props.variant;
  let captureEvent = SessionTracker.useCaptureEvent();
  let match = Navigation.useUrl();
  let editRouterOptions = Stdlib_Option.map(match.state, state => ({
    state: state
  }));
  let headerRef = React.useRef(null);
  let match$1 = Hover.use(undefined, true, undefined);
  let formattedSiret = CompanyLegalNumber.French.format(siret);
  let match$2;
  match$2 = variant.TAG === "Details" ? [formattedSiret, companyName] : [companyName, [formattedSiret, [suggestion.postalCode, suggestion.city].filter(value => value !== "").join(" ")].filter(value => value !== "").join(" - ")];
  let useButton;
  if (variant.TAG === "Details") {
    useButton = JsxRuntime.jsx(Button.make, {
      label: I18n.t(i18nPrefix + "use_button.label"),
      tone: "information",
      size: "small",
      noShrink: true,
      tooltipText: I18n.t(i18nPrefix + "use_button.tooltip_text"),
      href: CustomerRoutes.editRoute(variant.customerId, siret),
      routerOptions: editRouterOptions,
      onPress: () => captureEvent("customer_company_suggestion_click_use")
    });
  } else {
    let onUse = variant.onUse;
    useButton = JsxRuntime.jsx(Button.make, {
      label: I18n.t(i18nPrefix + "form_use_button.label"),
      tone: "information",
      size: "small",
      noShrink: true,
      tooltipText: I18n.t(i18nPrefix + "form_use_button.tooltip_text"),
      onPress: () => {
        captureEvent("customer_company_suggestion_click_use");
        onUse(siret);
      }
    });
  }
  let header;
  header = variant.TAG === "Details" ? JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(Title.make, {
        children: I18n.t(i18nPrefix + "title"),
        level: 5,
        weight: "semibold",
        color: "#767589"
      }), JsxRuntime.jsx(TooltipIcon.make, {
        children: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t(i18nPrefix + "title.tooltip_text")
        }),
        variation: "quiet_info",
        altTriggerRef: headerRef,
        iconSize: 15
      })],
      space: "xsmall"
    }),
    ref: Primitive_option.some(headerRef)
  }) : null;
  return JsxRuntime.jsxs(Stack.make, {
    children: [header, JsxRuntime.jsx("div", {
      children: JsxRuntime.jsx(CanarySurface.make, {
        tone: "information",
        borderStyle: "dashed",
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsxs(Inline.make, {
              children: [JsxRuntime.jsx(View.make, {
                className: "backgroundImage-x1uzhv9z backgroundPosition-x1xsqp64 backgroundRepeat-xiy17q3 backgroundSize-x18d0r48 flexShrink-x2lah0s height-x1fgtraw width-xgd8bvy",
                "data-style-src": "wino-gc:src/modules/Customer/CustomerCompanySuggestion.res.js:782"
              }), JsxRuntime.jsxs(Stack.make, {
                children: [JsxRuntime.jsx(Title.make, {
                  children: match$2[0],
                  level: 5,
                  weight: "semibold",
                  minChar: 6
                }), JsxRuntime.jsx(Title.make, {
                  children: match$2[1],
                  level: 6,
                  weight: "medium",
                  minChar: 15
                })],
                space: "xxsmall"
              })],
              space: "small",
              alignY: "center",
              shrink: true
            }), JsxRuntime.jsxs(Inline.make, {
              children: [JsxRuntime.jsx(AnimatedRender.make, {
                children: JsxRuntime.jsx(Button.make, {
                  tone: {
                    NAME: "neutral",
                    VAL: {
                      accent: true
                    }
                  },
                  size: "small",
                  icon: "external_link",
                  tooltipText: I18n.t(i18nPrefix + "annuaire_link_button.tooltip_text"),
                  href: CompanyLegalNumber.French.registryUrl(siret),
                  target: "_blank"
                }),
                displayed: match$1[1],
                animation: "fade"
              }), useButton],
              space: "small"
            })],
            space: "normal",
            align: "spaceBetween",
            alignY: "center"
          }),
          spaceX: "xmedium",
          spaceY: "xmedium"
        })
      }),
      ref: Primitive_option.some(match$1[0])
    })],
    space: "normal"
  });
}
let CompanySuggestionSurface = {
  make: CustomerCompanySuggestion$CompanySuggestionSurface
};
function CustomerCompanySuggestion(props) {
  let __skip = props.skip;
  let variant = props.variant;
  let criteria = props.criteria;
  let skip = __skip !== undefined ? __skip : false;
  let criteriaKey$1 = criteriaKey(criteria);
  let debouncedCriteriaKey = ReactUpdateDebounced.use(criteriaKey$1, 500);
  let suggestionResult = use(criteria, skip || debouncedCriteriaKey !== criteriaKey$1, undefined);
  if (typeof suggestionResult !== "object") {
    return null;
  }
  if (suggestionResult.TAG !== "Done") {
    return null;
  }
  let match = suggestionResult._0;
  if (match.TAG !== "Ok") {
    return null;
  }
  let suggestion = match._0;
  if (suggestion !== undefined) {
    if (variant.TAG === "Details") {
      return JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(CanarySeparator.make, {
          orientation: "horizontal"
        }), JsxRuntime.jsx(CustomerCompanySuggestion$CompanySuggestionSurface, {
          variant: variant,
          suggestion: suggestion
        })]
      });
    } else {
      return JsxRuntime.jsx(CustomerCompanySuggestion$CompanySuggestionSurface, {
        variant: variant,
        suggestion: suggestion
      });
    }
  } else {
    return null;
  }
}
let debounceDelay = 500;
let make$2 = CustomerCompanySuggestion;
export { Engine, i18nPrefix, debounceDelay, isCountryEligible, styles, CompanySuggestionSurface, make$2 as make };
/* diacritics Not a pure module */